
import { computed, ref, onMounted, nextTick } from 'vue'
export default {
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    loading: {
      type: Boolean,
      default: () => false
    }
  },
  setup (props, { emit }) {
    const visibleCompu = computed(() => props.visible)

    const loadingCompu = computed(() => props.loading)

    const formData = ref({})

    const formRef = ref()

    const inputRef = ref()
    const handleInputOk = () => {
      formRef.value.validate().then(() => {
        emit('onOk', formData.value.name)
      })
    }

    const handleCancel = () => {
      emit('onCancel')
    }
    onMounted(async () => {
      await nextTick()
      inputRef.value.focus()
    })

    return {
      formData,
      visibleCompu,
      formRef,
      loadingCompu,
      handleInputOk,
      handleCancel,
      inputRef
    }
  }

}
